export default __webpack_public_path__ + "static/media/logo_kplus_2.a6391350.svg";